import { VoidCallback1 } from '@deqo/foundation';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { WorkspaceFolderLiteData, WorkspaceLiteData } from '../../api/ApiTypes';
import { Select } from '../../ui';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { labelSorter } from '../dashboard/Models';

type LocationItem = {
    workspaceId: string,
    folderId?: string,
    label: string,
    longLabel: string,
};

const workspaceItem = (workspace: WorkspaceLiteData): LocationItem => ({
    workspaceId: workspace.id,
    label: workspace.label,
    longLabel: workspace.label,
});

const folderItem = (workspace: WorkspaceLiteData, folder: WorkspaceFolderLiteData): LocationItem => ({
    workspaceId: workspace.id,
    folderId: folder.id,
    label: `└── ${folder.label}`,
    longLabel: `${workspace.label} / ${folder.label}`,
});

export type AccountLocation = {
    workspaceId: string,
    folderId?: string,
};

export const AccountLocationSelector: LFC<{ initial?: AccountLocation, onSelect: VoidCallback1<AccountLocation> }> = ({ initial, onSelect }) => {
    const { workspaces } = useObserver(useResolve(AccountModel));
    const [selected, setSelected] = useState<LocationItem>();
    const items = useMemo(() =>
        workspaces?.slice().filter(x => x.type !== 'library').sort(labelSorter).flatMap(w => [
            workspaceItem(w),
            ...w.folders.slice().sort(labelSorter).map(f => folderItem(w, f))
        ])
        , [workspaces]);

    const onChange = useCallback((x: LocationItem) => {
        setSelected(x);
        onSelect(x);
    }, [onSelect]);

    useEffect(() => setSelected(items?.find(x => x.workspaceId === initial.workspaceId && x.folderId === initial.folderId) ?? null), [items]);

    return <Select items={items} selected={selected} onChange={onChange} renderSelected={
        (item) => <div>{item?.longLabel}</div>
    } />;
};
